<template>
	<v-toolbar app clipped-right dark fixed>
		<v-toolbar-title class="mr-3">
			<a href="/" style="outline: none;">
				<v-img src="/img/aska-logo-small.png" width="32" height="32" />
			</a>
		</v-toolbar-title>

		<v-toolbar-items v-if="!navMobile">
			<template v-for="(item, i) in navLinks">
				<component
					:is="item.comp"
					v-if="item.comp"
					:key="'appToolbarItem' + i"
				/>
				<v-btn v-else-if="item.href && item.href.split('.').pop() == 'pdf'" :key="'appToolbarItem' + i" v-external flat :href="item.href">
					{{ item.text }}
					<v-icon small class="ml-1">open_in_new</v-icon>
				</v-btn>
				<v-btn v-else :key="'appToolbarItem' + i" flat :href="item.href">{{ item.text }}</v-btn>
			</template>
		</v-toolbar-items>

		<v-spacer />

		<app-contact-btns />

		<!-- Hamburger icon button to open nav drawer on mobile. -->
		<v-toolbar-side-icon v-if="navMobile" @click.stop="$emit('toggle')" />
	</v-toolbar>
</template>

<script>
export default {
	props: {
		navLinks: { type: Array, required: true },
	},

	computed: {
		navMobile: function() {
			return this.$vuetify.breakpoint.smAndDown
		},
	},
}
</script>
